import React from 'react';

/**
 * Get Monday of the week containing the given date.
 */
function getMondayOf(date) {
  const d = new Date(date);
  const day = d.getUTCDay(); // 0=Sun
  const diff = (day === 0 ? -6 : 1 - day);
  d.setUTCDate(d.getUTCDate() + diff);
  return d;
}

function formatDateStr(date) {
  return date.toISOString().slice(0, 10);
}

function formatDisplay(monday) {
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const opts = { day: 'numeric', month: 'short' };
  const yearOpts = { day: 'numeric', month: 'short', year: 'numeric' };

  if (monday.getFullYear() === sunday.getFullYear()) {
    return `${monday.toLocaleDateString('en-AU', opts)} – ${sunday.toLocaleDateString('en-AU', yearOpts)}`;
  }
  return `${monday.toLocaleDateString('en-AU', yearOpts)} – ${sunday.toLocaleDateString('en-AU', yearOpts)}`;
}

/**
 * WeekPicker component.
 *
 * Props:
 *   weekStart: string  YYYY-MM-DD (must be a Monday)
 *   onChange(weekStart: string): void
 */
export default function WeekPicker({ weekStart, onChange }) {
  const monday = getMondayOf(new Date(weekStart + 'T00:00:00Z'));

  function prev() {
    const d = new Date(monday);
    d.setUTCDate(d.getUTCDate() - 7);
    onChange(formatDateStr(getMondayOf(d)));
  }

  function next() {
    const d = new Date(monday);
    d.setUTCDate(d.getUTCDate() + 7);
    onChange(formatDateStr(getMondayOf(d)));
  }

  function goToday() {
    onChange(formatDateStr(getMondayOf(new Date())));
  }

  const currentMonday = formatDateStr(getMondayOf(new Date()));
  const isCurrentWeek = formatDateStr(monday) === currentMonday;

  return (
    <div className="week-picker">
      <button className="week-nav-btn" onClick={prev} title="Previous week">
        &#8249;
      </button>
      <span className="week-picker-label">{formatDisplay(monday)}</span>
      <button className="week-nav-btn" onClick={next} title="Next week">
        &#8250;
      </button>
      {!isCurrentWeek && (
        <button className="btn btn-secondary btn-sm" onClick={goToday} style={{ marginLeft: 8 }}>
          This Week
        </button>
      )}
    </div>
  );
}
